import { RootReducer } from '../rootReducer';

export const selectDeepLink = (state: RootReducer) => state.deepLink.url;
